import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from './redux/HeaderActions';
import * as registrationPopupActions from '../RegistrationPopup/redux/registrationPopupActions';
import * as signInPopupActions from '../SignInPopup/redux/signInPopupActions';
import styles from './Header.scss';
import HeaderLogo from './elements/HeaderLogo.jsx';
import HeaderLocation from './elements/HeaderLocation.jsx';
import HeaderCart from './elements/HeaderCart.jsx';
import HeaderContacts from './elements/HeaderContacts.jsx';
import HeaderAuthBlock from './elements/HeaderAuthBlock.jsx';
import HeaderMobileAuthBtn from './elements/HeaderMobileAuthBtn.jsx';
import Media from 'react-responsive';

export class HeaderFirstLvl extends Component {
  render() {

    return (
      <div className={styles.headerWrapper}>
        <div className={ styles.header }>
          <HeaderLogo />
          <div className={styles.space} />

          <HeaderCart cartItemsCount={this.props.cartItemsCount || 0} />
          <Media query="(min-width: 1025px)">
            <div>
              <HeaderContacts />
              <HeaderAuthBlock {...this.props} />
            </div>
          </Media>
          <Media query="(max-width: 1024px)">
            <HeaderMobileAuthBtn {...this.props} />
          </Media>
        </div>
      </div>
    );
  }
}



HeaderFirstLvl.propTypes = {
  actions: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    ...state.appReducer,
    cartItemsCount: state.cart2Reducer.cartItemsCount
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, ...registrationPopupActions, ...signInPopupActions }, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HeaderFirstLvl);



/** WEBPACK FOOTER **
 ** ./src/components/Header/HeaderFirstLvl.jsx
 **/